<script>
export default {
  props: {
    html: { type: String, default: '' }
  },
  methods: {
    renderNode(h, node) {
      if (node.nodeType === Node.TEXT_NODE) return node.nodeValue
      if (node.nodeType !== Node.ELEMENT_NODE) return null

      const tag = node.tagName.toLowerCase()
      const data = { attrs: {} }
      Array.prototype.slice.call(node.attributes || []).forEach(attribute => {
        if (attribute.name === 'class') data.class = attribute.value
        else data.attrs[attribute.name] = attribute.value
      })

      if (tag === 'a' && (` ${node.getAttribute('class') || ''} `).indexOf(' evi ') !== -1) {
        data.on = {
          click: event => {
            event.preventDefault()
            this.$emit('citation', {
              anchor: event.currentTarget,
              citationNumber: Number(node.getAttribute('data-citation-n')),
              claimIndex: node.hasAttribute('data-claim-index')
                ? Number(node.getAttribute('data-claim-index'))
                : null
            })
          }
        }
      }

      const children = Array.prototype.slice.call(node.childNodes)
        .map(child => this.renderNode(h, child))
        .filter(child => child !== null)
      return h(tag, data, children)
    }
  },
  render(h) {
    const container = document.createElement('div')
    container.innerHTML = this.html
    const children = Array.prototype.slice.call(container.childNodes)
      .map(node => this.renderNode(h, node))
      .filter(node => node !== null)
    return h('div', { class: 'message-content hmrag-markdown' }, children)
  }
}
</script>
